// extracted by mini-css-extract-plugin
export default {"YoutubeEmbed":"bau_a"};